import { Component, OnDestroy } from '@angular/core';
import { combineLatest, Observable, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { sum } from 'lodash';
import { _ } from '~app/shared/utils';
import { default as getTenantConfig, ValmetDnaTagConfig } from '~shared/map/layer/layer-definitions/T14';
import { NeveMeasurementsService } from './measurements/neve-measurements.service';
import { last } from 'lodash-es';

interface Row {
  label: string;
  unit: string;
  value$: Observable<number>;
}

@Component({
  selector: 'qm-neve-measurements-toolbar',
  templateUrl: './neve-measurements-toolbar.component.html',
  styleUrls: ['./neve-measurements-toolbar.component.scss']
})
export class NeveMeasurementsToolbarComponent implements OnDestroy {
  public readonly rows: Row[];

  private readonly ngUnsubscribe = new Subject<void>();

  constructor(
    private readonly measurements: NeveMeasurementsService,
  ) {
    this.rows = [
      {
        label: _('Main network (heat)'),
        unit: 'MW',
        value$: this.sumTags$(getTenantConfig().tenantCustomData.valmetDnaTags.powerInfo.mainNetwork),
      },
      {
        label: _('Main grid (electricity)'),
        unit: 'MW',
        value$: this.sumTags$(getTenantConfig().tenantCustomData.valmetDnaTags.electricityInfo),
      },
    ];
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  /**
   * Computes the total sum of the latest known values of the given tags.
   */
  private sumTags$(tags: ValmetDnaTagConfig[]): Observable<number> {
    return combineLatest(
      tags.map(tag => this.measurements.tagState$(tag.tagpair).pipe(
        filter(state => state.status === 'loaded'),
        map(state => tag.valueTransformer(last(state.measurements)).numericValue),
        takeUntil(this.ngUnsubscribe),
      ))
    ).pipe(
      map(values => Math.round(sum(values))),
      takeUntil(this.ngUnsubscribe),
    );
  }
}
